export default __webpack_public_path__ + "static/media/flowchart_whitebg.d68e7a58.png";